// extracted by mini-css-extract-plugin
export default {"stars":"styles_stars__R-pVg"};